import { render, staticRenderFns } from "./Carousel_new1.vue?vue&type=template&id=47e10bf0&"
import script from "./Carousel_new1.vue?vue&type=script&lang=js&"
export * from "./Carousel_new1.vue?vue&type=script&lang=js&"
import style0 from "./Carousel_new1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports